import * as React from "react";

const CENHomeArrowRightFirst: React.FC = () => {
    return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.6695 6.79507L13.1695 11.2951C12.7297 11.7349 12.0178 11.7342 11.5787 11.2951C11.1393 10.8556 11.1393 10.1437 11.5787 9.70425L14.1609 7.12554H1.125C0.503086 7.12554 0 6.62281 0 5.9689C0 5.315 0.503086 4.87554 1.125 4.87554H14.1609L11.5812 2.29578C11.1417 1.85632 11.1417 1.14441 11.5812 0.704956C12.0206 0.265503 12.7325 0.265503 13.172 0.704956L17.672 5.20496C18.109 5.64546 18.109 6.35562 17.6695 6.79507Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(CENHomeArrowRightFirst);
